import { createFeatureSelector, createSelector } from '@ngrx/store';

import {
  SUBSCRIPTION_FEATURE_KEY,
  SubscriptionState,
} from '../subscription.state';

export const selectSubscriptionState = createFeatureSelector<SubscriptionState>(
  SUBSCRIPTION_FEATURE_KEY
);

export const selectCurrentSubscriptionState = createSelector(
  selectSubscriptionState,
  (state) => state.current
);

export const selectIsCurrentSubscriptionLoaded = createSelector(
  selectCurrentSubscriptionState,
  (state) => state.loadStatus === 'success'
);

export const selectCurrentLicenseName = createSelector(
  selectCurrentSubscriptionState,
  (state) => state.subscription?.license ?? ''
);
